<template>
  <div
    v-if="editingMode"
    class="PersonCardHeaderEditing d-flex-column"
  >
    <div class="d-flex">
      <h2 class="h-2 label">
        {{ $t('common.action.drawer-update') }}
      </h2>
      <h2 class="h-2 name">{{ title }}</h2>
    </div>
    <div class="details">
      <h5 class="h-5 lastUpdate">
        {{ $t('common.last-update', { date: lastUpdateDisplay }) }}
      </h5>
    </div>
  </div>
  <div
    v-else
    class="PersonCardHeader d-flex"
  >
    <svg class="avatar rounded">
      <SvgImage :type="type" />
    </svg>
    <div class="details">
      <h2 class="h-2-bold label">{{ internalLabel }}</h2>
      <h5 class="h-5-bold lastUpdate">
        {{ $t('common.last-update', { date: lastUpdateDisplay }) }}
      </h5>
    </div>
  </div>
</template>

<script>
  import SvgImage from '@/components/common/SvgImage/SvgImage'

  export default {
    components: {
      SvgImage,
    },
    props: {
      firstName: {
        type: String,
        default: null,
      },
      lastName: {
        type: String,
        default: null,
      },
      lastUpdate: {
        type: [Date, String,],
        required: true,
      },
      type: {
        type: String,
        default: 'moral',
      },
      editingMode: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        default: '',
      },
    },
    computed: {
      lastUpdateDisplay() {
        return this.$d(new Date(this.lastUpdate), 'short')
      },
      internalLabel() {
        if (this.firstName === null || this.lastName === null) {
          return this.$t('common.not_specified')
        } else {
          return `${this.firstName} ${this.lastName}`
        }
      },
    },
  }
</script>

<style scoped lang="scss">
.PersonCardHeader {
  .avatar {
    flex: 0 0 56px;
    width: 56px;
    height: 56px;
    margin-right: 16px;
  }
  .label {
    color: $color-001c4b;
  }
  .lastUpdate {
    margin-top: 0.5rem;
    font-size: 0.8rem;
    font-weight: 500;
    color: $color-9e9fa2;
    text-transform: uppercase;
  }
}
.PersonCardHeaderEditing {
  .label {
    font-weight: 600;
    color: $color-001c4b;
  }
  .name {
    font-weight: 600;
    color: $color-009ee0;
  }
  .lastUpdate {
    margin-top: 0.5rem;
    font-size: 0.8rem;
    font-weight: 500;
    color: $color-9e9fa2;
    text-transform: uppercase;
  }
}
</style>
